export const getNonZeroQueries = <T extends unknown>(o: T) => {
	const nonZero = (val: any) => val != 0 && val != null && val !== undefined;
	const results = (obj: any) =>
		Object.keys(obj)
			.filter(key => nonZero(obj[key]))
			.reduce((res, key) => (((res as any)[key] = obj[key]), res), {});
	return results(o) as Partial<T>;
};
